<template>
    <svg width="14"
         height="14"
         viewBox="0 0 14 14"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_11456_9681)">
            <path d="M12.25 12.25L1.75 12.25M10.5 6.41667L7 9.91667M7 9.91667L3.5 6.41667M7 9.91667L7 1.75"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_11456_9681">
                <rect width="14"
                      height="14"
                      fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'IconDownload'
};
</script>
